import useParams from './useParams';
export default useParams;
